<!--添加多个充电枪 form表单-->
<template>
    <v-card :color="theme.elementBgColor" v-loading.fullscreen.lock="addLoading">
        <v-card-title>
            添加多把充电枪
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="8vw" class="pb-6" label-position="top">
                <el-form-item label="站点" :rules="[{ required: true }]">
                    <select-site
                        v-if="isSite"
                        :selectSite="form.selectSite"
                        @choose="chooseSite"
                        :width="'60%'"
                    />
                </el-form-item>
                <el-form-item label="充电桩" :rules="[{ required: true }]">
                    <select-pile
                        v-if="isSite"
                        @choose="choosePile"
                        :siteId="form.selectSite"
                        :width="'60%'"
                        :multiple="multiple"
                        :pileId="form.equipment_id"
                    />
                </el-form-item>
                <el-form-item label="充电枪名称后缀" :rules="[{ required: true }]">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="充电枪名称：需要添加枪的桩的名称+输入的后缀（比如：******桩A枪）"
                        placement="top"
                    >
                        <el-input v-model="form.name_suffix" autocomplete="off" style="width: 60%">
                            <span slot="append">枪</span>
                        </el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="充电枪编号后缀" :rules="[{ required: true }]">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="充电枪编号：需要添加枪的充电桩编码+输入的后缀（比如编号为：TCB120CN44120001A 下方就输入A）"
                        placement="top"
                    >
                        <el-input
                            v-model="form.connector_id_suffix"
                            autocomplete="off"
                            style="width: 60%"
                        >
                            <!-- <span slot="append">N</span> -->
                        </el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="" :rules="[{ required: true }]">
                    <div style="display:flex;flex-direction:row;align-items:center;">
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.v_upper" autocomplete="off" placeholder="">
                                    <span slot="prepend">电压上限</span>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div style="width:10%"></div>
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.v_lower" autocomplete="off" placeholder="">
                                    <span slot="prepend">电压下限</span>
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" :rules="[{ required: true }]">
                    <div style="display:flex;flex-direction:row;align-items:center;">
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.current" autocomplete="off" placeholder="">
                                    <span slot="prepend">电流</span>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div style="width:10%"></div>
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.power" autocomplete="off" placeholder="">
                                    <span slot="prepend">额定功率</span>
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="设备类型" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in typeText"
                        :key="index"
                        v-model="form.type"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
                <el-form-item label="设备状态" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in statusText"
                        :key="index"
                        v-model="form.status"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import util from "@/util";
import Public from "@/public"
import SelectSite from "@/components/SelectSite";
import SelectPile from "@/components/SelectPile";
import { mapState } from "vuex";
import store from "@/store";
import axios from "axios";
export default {
    data() {
        return {
            form: {
                id: null,
                name_suffix: "A",
                connector_id_suffix: "A",
                equipment_id: null, //选中的充电桩id
                selectSite: null, //选中的站点id
                current: null,
                power: null,
                status: null,
                type: null,
                updatetime: null,
                v_lower: null,
                v_upper: null,
            },
            isSite: true,
            multiple: true, //充电桩是否多选
            connectorIdArray: null,
            typeText: [
                {
                    id: 1,
                    value: "家用插座",
                },
                {
                    id: 2,
                    value: "交流插座",
                },
                {
                    id: 3,
                    value: "交流桩",
                },
                {
                    id: 4,
                    value: "直流桩",
                },
                {
                    id: 5,
                    value: "无线",
                },
                {
                    id: 6,
                    value: "其他",
                },
            ],
            statusText: [
                {
                    id: 0,
                    value: "离线",
                },
                {
                    id: 1,
                    value: "空闲",
                },
                {
                    id: 2,
                    value: "占用（未充电）",
                },
                {
                    id: 3,
                    value: "占用（充电中）",
                },
                {
                    id: 4,
                    value: "占用（预约锁定）",
                },
                {
                    id: 254,
                    value: "冻结",
                },
                {
                    id: 255,
                    value: "故障",
                },
            ],
            addLoading: false,
        };
    },
    watch: {
        "form.selectSite": {
            handler(val) {
                if (!this.station_id) {
                    this.isSite = false;
                    this.$nextTick(() => {
                        this.isSite = true;
                    });
                }
                this.getEquipmentInfo();
            },
            deep: true,
        },
        station_id: {
            handler(val) {
                if (val) {
                    this.form["selectSite"] = val;
                }
            },
        },
    },
    created() {
        Object.keys(this.form).forEach(key => {
            if (key != "name_suffix" && key != "connector_id_suffix") {
                this.form[key] = null;
            }
        });
    },
    mounted() {
        this.form["selectSite"] = this.station_id;
    },
    props: {
        station_id: Number,
    },
    components: {
        SelectSite,
        SelectPile,
    },
    computed: {
        ...mapState([
            "contactInfo",
            "connectorInfo",
            "gunData",
            "TipType",
            "theme",
            "equipmentInfo",
        ]),
    },
    methods: {
        async getEquipmentInfo() {
            let postData = {
                station_id: this.form["selectSite"],
            };
            await store.dispatch("getEquipment", postData);
        },
        /*选择站点*/
        async chooseSite(site) {
            this.form["selectSite"] = site.siteId;
            this.form["equipment_id"] = null;
            let postData = {
                station_id: site.siteId,
            };
            await store.dispatch("getConnector", postData);
        },
        /*获取充电枪数据 用于判断是否存在相同的充电枪编号*/
        async getConnectorInfo() {
            let postData = {
                station_id: this.form["selectSite"],
                // from: 0,
                // limit: 10000,
            };
            await store.dispatch("getConnector", postData);
            this.gunInfos = JSON.parse(JSON.stringify(this.connectorInfo.reverse()));
            this.connectorIdArray = [];
            for (let i = 0; i < this.gunInfos.length; i++) {
                this.connectorIdArray.push(this.gunInfos[i].connector_id);
            }
        },
        /*选择充电桩*/
        choosePile(pile) {
            this.form["equipment_id"] = pile;
        },
        /*获取当前时间格式为 yyyy-mm-dd hh-mm-ss*/
        getFormatDate() {
            var date = new Date();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentDate =
                date.getFullYear() +
                "-" +
                month +
                "-" +
                strDate +
                " " +
                date.getHours() +
                ":" +
                date.getMinutes() +
                ":" +
                date.getSeconds();
            return currentDate;
        },
        /*确定添加*/
        determine() {
            if (this.equipmentInfo.length == 0) {
                util.ShowTip("充电桩不存在", 3);
                return;
            }
            let form = Object.assign({}, this.form);
            delete form.id;
            delete form.status;
            delete form.updatetime;
            let nullKeyArr = Object.keys(form).filter(key => !form[key]);
            if (nullKeyArr.length != 0) {
                let utilText = "";
                for (let i1 = 0; i1 < nullKeyArr.length; i1++) {
                    if (i1 == nullKeyArr.length - 1) {
                        utilText = utilText + this.utilText(nullKeyArr[i1]);
                    } else {
                        utilText = utilText + this.utilText(nullKeyArr[i1]) + "、";
                    }
                }
                if (this.form["status"] == null) {
                    if (utilText != "") {
                        utilText = utilText + "、设备状态";
                    } else {
                        utilText = "设备状态";
                    }
                }
                util.ShowTip(utilText + "不能为空", 3);
                return;
            }
            this.addLoading = true;
            let equipment_id = this.form["equipment_id"];
            let postDataArr = [];
            for (let i = 0; i < equipment_id.length; i++) {
                let equipment_info;
                for (let j = 0; j < this.equipmentInfo.length; j++) {
                    if (equipment_id[i] == this.equipmentInfo[j].id) {
                        equipment_info = this.equipmentInfo[j];
                    }
                }
                let params = {
                    postData: {
                        connector: {
                            equipment_id: equipment_info.id,
                            name: Public.removeSpace(equipment_info.name + this.trim(this.form["name_suffix"]) + "枪"),
                            connector_id:
                                Public.removeSpace(equipment_info.cec_equipment_id +
                                this.trim(this.form["connector_id_suffix"])),
                            current: Number(this.form["current"]),
                            power: Number(this.form["power"]),
                            status: this.form["status"],
                            type: this.form["type"],
                            v_lower: Number(this.form["v_lower"]),
                            v_upper: Number(this.form["v_upper"]),
                        },
                    },
                    isMore: true,
                    callback: () => {},
                };
                postDataArr.push(store.dispatch("addConnector", params));
            }
            let that = this;
            axios.all(postDataArr).then(res => {
                for (let i = 0; i < res.length; i++) {
                    if (res[i] == undefined) {
                        util.ShowTip("添加成功", 1);
                    } else {
                        util.ShowTip(res[i], 2);
                    }
                }
                that.addLoading = false;
                that.$emit("refresh");
                that.loading = false;
                that.cancel();
            });
        },
        /*返回相应为空值指的文本*/
        utilText(key) {
            let text = "";
            if (key == "name_suffix") {
                text = "充电枪名称后缀";
            } else if (key == "connector_id_suffix") {
                text = "充电枪编号后缀";
            } else if (key == "equipment_id") {
                text = "充电桩";
            } else if (key == "current") {
                text = "电流";
            } else if (key == "power") {
                text = "功率";
            } else if (key == "type") {
                text = "设备类型";
            } else if (key == "v_lower") {
                text = "电压下限";
            } else if (key == "v_upper") {
                text = "电压上限";
            }
            return text;
        },
        /*取消添加*/
        cancel() {
            Object.keys(this.form).forEach(key => {
                if (key != "station_id") {
                    this.form[key] = null;
                }
            });
            this.$emit("cancel");
        },
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
    },
};
</script>
